import React from 'react';
import PageShell from '../components/page/PageShell';
import PageHeader from '../components/page/PageHeader';
import PageTabs from '../components/page/PageTabs';
import { useApp } from '../context/AppContext';
import { Role } from '../constants/roles';
import ConnectionsTab from '../components/integrations/ConnectionsTab';
import OpenApiTab from '../components/integrations/OpenApiTab';

/**
 * Integrations hub: the single sidebar destination for third-party connections, the Pathkey feed, platform feed
 * keys (admin) and Open API keys. Design: .claude/design/integrations-module.md.
 *
 * Renders for Lead Advisor and ProLense Admin only; every card and write is also enforced by the API (this gate
 * is presentation). Secrets are write-only everywhere: no response carries one, forms always start empty.
 */
const IntegrationsPage = () => {
    const { user } = useApp();
    const role = user?.role;
    if (role !== Role.LEAD_ADVISOR && role !== Role.ADMIN) return null;

    const intro = role === Role.ADMIN
        ? 'Manage platform feed keys and configure Lead Advisor integrations on their behalf. Secrets are encrypted at rest and never displayed again after saving.'
        : 'Bring your own accounts. Credentials you enter here belong to your firm, are encrypted at rest, and are never displayed again after saving.';

    return (
        <PageShell width="wide">
            <PageHeader title="Integrations" subtitle={intro} />
            <PageTabs
                defaultActiveKey="connections"
                items={[
                    { key: 'connections', label: 'Connections', children: <ConnectionsTab role={role} /> },
                    { key: 'open-api', label: 'Open API', children: <OpenApiTab role={role} /> },
                ]}
            />
        </PageShell>
    );
};

export default IntegrationsPage;
